"use client"

import { useEffect, useState } from "react"
import { ServerIcon, WifiOffIcon } from "lucide-react"

type Status = "checking" | "online" | "offline"

export function ServerStatus() {
  const [status, setStatus] = useState<Status>("checking")

  useEffect(() => {
    const url = process.env.NEXT_PUBLIC_API_URL

    if (!url) {
      setStatus("offline")
      return
    }

    const controller = new AbortController()
    const timeout = setTimeout(() => controller.abort(), 5000)

    fetch(url, { method: "HEAD", signal: controller.signal })
      .then(() => setStatus("online"))
      .catch(() => setStatus("offline"))
      .finally(() => clearTimeout(timeout))

    return () => {
      controller.abort()
      clearTimeout(timeout)
    }
  }, [])

  return (
    <div className="flex items-center justify-center gap-1.5 text-xs text-muted-foreground">
      {status === "checking" && (
        <>
          <ServerIcon className="size-3 animate-pulse" />
          <span>Verificando servidor...</span>
        </>
      )}
      {status === "online" && (
        <>
          <ServerIcon className="size-3 text-green-500" />
          <span className="text-green-500">Servidor online</span>
        </>
      )}
      {status === "offline" && (
        <>
          <WifiOffIcon className="size-3 text-destructive" />
          <span className="text-destructive">Servidor offline</span>
        </>
      )}
    </div>
  )
}
